// UserLastSeenView.jsx
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import {
  getUserCreationDateRows,
  getUserLastSeenRows,
  getUserLastUpdateDateRows,
} from "./checkRowsUserData";

const UserLastAndFirstSeenView = ({ entityData }) => {
  const [firstSeenRows, setFirstSeenRows] = useState([]);
  const [lastSeenRows, setLastSeenRows] = useState([]);
  const [lastUpdatedRows, setLastUpdatedRows] = useState([]);

  useEffect(() => {
    setLastSeenRows(getUserLastSeenRows(entityData));
    setFirstSeenRows(getUserCreationDateRows(entityData));
    setLastUpdatedRows(getUserLastUpdateDateRows(entityData));
  }, [entityData]);

  return (
    (lastSeenRows.length > 0 ||
      firstSeenRows.length > 0 ||
      lastUpdatedRows.length > 0) && (
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        {lastSeenRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant="subtitle2">Last seen</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastSeenRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_seen}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {firstSeenRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant="subtitle2">Creation Date</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {firstSeenRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.creation_date}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
        {lastUpdatedRows.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box display={"flex"} gap={1} alignItems={"center"}>
              <Typography variant={"subtitle2"}>Last Updated</Typography>
            </Box>
            <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
              {lastUpdatedRows.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_updated}
                ></TextIntegrationStyle>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    )
  );
};

export default UserLastAndFirstSeenView;
